<ul class="header-div-ul">
  <ng-container *ngIf="isSurveyDraft || isRecontactSurvey">
    <li class="header-div-li" *ngIf="totalClicks">
      <div>
        <h6 class="header-div-h6">CLICKS</h6>
        <span class="header-div-span">{{ totalClicks }}</span>
      </div>
    </li>
    <!-- Create Survey Header -->
    <ng-container *ngIf="isNewSurvey && !isTCSPAEditMode">
      <li class="header-div-li">
        <div>
          <h6 class="header-div-h6">Last Saved</h6>
          <span class="header-div-span">
            <ng-container *ngIf="surveyLastSaved !== 0"
              >{{ surveyLastSaved | date : 'MMM d, y, h:mm '
              }}{{ surveyLastSaved | date : 'a' | lowercase }}</ng-container
            >
          </span>
        </div>
      </li>

      <li
        *psUiConfigEnabled="'enableClickToCalculate'"
        class="header-div-li pb-0"
      >
        <div>
          <ps-ui-processing></ps-ui-processing>
        </div>
      </li>

      <li class="header-div-li pb-0" *ngIf="showTotalCompletes">
        <div>
          <h6 class="header-div-h6">{{ totalCompleteLabel }}</h6>
          <span class="header-div-span">
            <span>{{ totalCompletes }}</span>
          </span>
        </div>
      </li>
      <li class="header-div-li pb-0" *ngIf="!enableAdvanceFeasibilityDropDown">
        <div>
          <ps-ui-feasibility></ps-ui-feasibility>
        </div>
      </li>

      <li
        class="header-div-li pb-0 adv-feas-header"
        *psUiConfigEnabled="'enableAdvanceFeasibilityDropDown'"
      >
        <div>
          <ps-ui-advance-feasibility></ps-ui-advance-feasibility>
        </div>
      </li>

      <li class="header-div-li pb-0 cpi-header">
        <div>
          <ps-ui-cpi></ps-ui-cpi>
        </div>
      </li>
      <li class="header-div-li" *ngIf="!isMcSurvey">
        <div>
          <h6 class="header-div-h6">Field Time</h6>
          <span class="header-div-span">{{
            surveyFieldTime !== 0 ? surveyFieldTime : 0
          }}</span>
        </div>
      </li>
    </ng-container>
    <!-- Launch Survey Header -->
    <ng-container
      *ngIf="
        (isLaunchSurvey || isRecontactSurvey) && !isMcSurvey && !isTCSPAEditMode
      "
    >
      <ng-container *ngIf="!isRecontactSurvey">
        <li class="header-div-li">
          <div>
            <h6 class="header-div-h6">Completes</h6>
            <span class="header-div-span">{{ surveyCompletes }}</span>
          </div>
        </li>
        <li class="header-div-li">
          <div>
            <h6 class="header-div-h6">Cpi</h6>
            <span class="header-div-span">{{
              surveyCpi | currency : currencySymbol
            }}</span>
          </div>
        </li>
      </ng-container>
      <li class="header-div-li">
        <div>
          <h6 class="header-div-h6">Total Cost</h6>
          <span class="header-div-span">{{
            surveyTotalCost | currency : currencySymbol
          }}</span>
        </div>
      </li>
      <ng-container *ngIf="!isRecontactSurvey">
        <li class="header-div-li">
          <div>
            <h6 class="header-div-h6">Field Time</h6>
            <span class="header-div-span">{{
              surveyFieldTime !== 0 ? surveyFieldTime : 0
            }}</span>
          </div>
        </li>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="isLaunchSurvey && isMcSurvey && !isTCSPAEditMode">
      <li class="header-div-li">
        <div>
          <h6 class="header-div-h6">TOT COMPLETES</h6>
          <span class="header-div-span">{{ totalMulticountryCompletes }}</span>
        </div>
      </li>
      <li class="header-div-li">
        <div>
          <h6 class="header-div-h6">AVG CPI</h6>
          <span class="header-div-span">{{
            averageCpi | currency : currencySymbol
          }}</span>
        </div>
      </li>
      <li class="header-div-li">
        <div>
          <h6 class="header-div-h6">Total Cost</h6>
          <span class="header-div-span">{{
            totalCost | currency : currencySymbol
          }}</span>
        </div>
      </li>
      <li class="header-div-li" *ngIf="!isMcSurvey">
        <div>
          <h6 class="header-div-h6">Field Time</h6>
          <span class="header-div-span">{{
            surveyFieldTime !== 0 ? surveyFieldTime : 0
          }}</span>
        </div>
      </li>
    </ng-container>
  </ng-container>
  <li *ngIf="showCloseButton" class="header-div-li">
    <div>
      <h6 class="header-div-h6 close" (click)="close()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </h6>
    </div>
  </li>
</ul>
